import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  loading?: boolean;
  children: ReactNode;
}

const variants = {
  primary: 'gf-button-primary',
  secondary: 'gf-button-secondary',
  ghost: 'gf-button-ghost',
  danger: 'bg-red-600 text-white hover:bg-red-500',
} as const;

export function Button({
  variant = 'primary',
  loading = false,
  disabled,
  className,
  children,
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      // A loading button must also be disabled, or a double click submits twice.
      disabled={disabled === true || loading}
      aria-busy={loading || undefined}
      className={cn(
        'gf-button',
        'disabled:cursor-not-allowed disabled:opacity-50',
        variants[variant],
        className,
      )}
    >
      {loading ? (
        <span
          aria-hidden
          className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      ) : null}
      {children}
    </button>
  );
}
